export const name = "CHAR_LENGTH";
export const summary = `Gets the number of characters in a \`STRING\` value.`;
export const reference = `
## CHAR_LENGTH

Gets the number of characters in a \`STRING\` value.

\`\`\`
CHAR_LENGTH(value)
\`\`\`

### Description

Gets the number of characters in a \`STRING\` value.


### Return type

\`INT64\`


### Examples



\`\`\`
SELECT CHAR_LENGTH('абвгд') AS char_length;

/*-------------*
 | char_length |
 +-------------+
 | 5 |
 *------------ */
\`\`\`


source: https://cloud.google.com/bigquery/docs/reference/standard-sql/string_functions
`;
